/**
 * Functions wrapper for LYRA data module
 * 
 * Author: Sahil David
 */
import { Dictionary } from '@/@types';
import store from '@/bootstrap/services/store';
import { getVersionApp } from '../../versions/services/versions.helpers';

import { ILyraEndpointsOptions } from '../@types/ILyraData';

/**
 * Sorts endpoints array based on its `order` property.
 * @param entries - array to sort.
 */
export function sortEntries (entries: any[]) {
	// TODO: check with Sahil why this is needed
	// const amount = entries.length;
	// const mapping = [...entries].filter((_: any) => parseFloat(_.order)).map((_: any) => _.order);

	// if (amount === mapping.length) {
	// 	return [...entries].sort((a: any, b: any) => parseFloat(a.order) - parseFloat(b.order));
	// }

	// return entries;

	return [...entries].sort((a: any, b: any) => parseFloat(a.meta.order) - parseFloat(b.meta.order));
}

export function addEndpointFallback (endpoint: any): Dictionary<any> {
	if (endpoint) {
		return Object.assign({}, endpoint, {
			...((endpoint || {}).meta || {}),
			...((endpoint || {}).parentTier || {}),
		});
	}
	return {};
}

export function addEndpointsFallback (endpoints: any[]): any[] {
	const output: any = [];
	endpoints.forEach((endpoint: Dictionary<any>) => {
		if (!endpoint) return;
		output.push(addEndpointFallback(endpoint));
	});
	return output;
}

/**
 * Function to get endpoints for a given tier
 * @param tierId - {string} tier to get endpoints from
 * @param option - {ILyraEndpointsOptions} options to apply to endpoints
 * @returns - array of endpoints for specified tier
 */
export function getLyraEndpoints (tierId: string, options: ILyraEndpointsOptions = {
	sort: true,
	version: true
}): any[] {
	const appManager = store.getters.get_appManager || [];
	const tier = appManager.find((_: any) => _.tierId === tierId);
	if (!tier) { return []; }

	let { endpoints } = tier;
	if (options.sort) {
		endpoints = sortEntries(endpoints || []);
	}

	if (options.version) {
		endpoints = endpoints.filter((_: any) => {
			if (_.meta.version) {
				return _.meta.version === getVersionApp();
			} else {
				return _;
			}
		})
	}
	return addEndpointsFallback(endpoints) || [];
}

/**
 * Return the endpoint obj
 * @param {String} endpointId - endpointId to get the record for
 * @param {String} tierId - tierId to get the record for
 */
export function getLyraEndpoint (endpointId: string, tierId: string) {
	const appManager = store.getters.get_appManager || [];

	// Endpoints
	const endpoints = appManager.find((_: any) => _.tierId === tierId) || {};
	const slides = endpoints.endpoints || [];

	return addEndpointFallback(slides.find((_: any) => _.endpointId === endpointId));
}

/**
 * Returns the citation object
 * @param citationKey - string key to get citation value for
 * @returns - return citation object if exists
 */
export function getLyraCitation (citationKey: string): any {
	const citations = store.getters.get_citations || [];
	const record = citations.find((_: any) => _.key === citationKey);

	if (!record) {
		console.warn(`[LYRA] No record found for citation key: ${citationKey}`);
		return;
	}

	return record;
}
